module.exports = __webpack_public_path__ + "static/media/Sahlender.b60fb14d.jpg";